import { render } from "./countryForm.vue?vue&type=template&id=ba52cc24&scoped=true"
import script from "./countryForm.vue?vue&type=script&lang=js"
export * from "./countryForm.vue?vue&type=script&lang=js"

import "./countryForm.vue?vue&type=style&index=0&id=ba52cc24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba52cc24"]])

export default __exports__